import React from 'react';

import LazyImage from '@/common/components/LazyImage';
import clsx from 'clsx';
const licenseImages = [
  {
    url: 'https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbTk1VDAwdlRuQm9VRUpSWW5ac2JVcHJjRzl2Y0ZFOVBTSXNJblpoYkhWbElqb2lTUzlTV0VKM1FVaFZaVUp0V0RaT1pVbEtjblUyUVQwOUlpd2liV0ZqSWpvaU1USTVaakUzWkRWak1UaGhZVEEzWkRCa016WTRNalEyTkRZNU1tRXlZMkUyT1dSaFpHTTRabUZsTTJReU5UTTRZVGhpWVdVeU5UUmpNRFZrWTJJek15SXNJblJoWnlJNklpSjk=',
    image: '/images/common/footer/L1.svg',
  },
  {
    url: '',
    image: '/images/common/footer/L2.svg',
  },
  {
    url: 'https://www.mga.org.mt/',
    image: '/images/common/footer/L3.svg',
  },
  {
    url: 'https://www.gamblingcommission.gov.uk/',
    image: '/images/common/footer/L4.svg',
  },
  {
    url: 'https://igamingontario.ca/en',
    image: '/images/common/footer/L5.svg',
  },
  {
    url: 'https://www.bigtimegaming.com/',
    image: '/images/common/footer/L6.svg',
  },
  {
    url: 'https://gamingcontrolboard.pa.gov/',
    image: '/images/common/footer/L7.svg',
  },
  {
    url: 'https://www.gamingcommission.gov.gr/',
    image: '/images/common/footer/L8.svg',
  },
  {
    url: 'https://www.gra.gi/',
    image: '/images/common/footer/L9.svg',
  },
];

/**
 * 底部页脚组件
 */
const Footer: React.FC = () => {
  return (
    <div className="w-full flex-col gap-14px max-w-1200px mx-auto flex pl-12px pr-12px rounded-t-12px pt-12px pb-24px">
      <p className="_tf[14] font-600 text-[var(--Text-Main-10)]">游戏牌照</p>
      <div className="w-full flex flex-row items-center gap-8px overflow-x-auto overflow-y-hidden">
        {licenseImages.map((item, index) => (
          <div
            key={index}
            className={clsx(
              'h-48px w-15% min-w-95px flex-shrink-0 flex items-center justify-center rounded-10px bg-[var(--Background-300)]',
              item.url && 'cursor-pointer',
            )}
          >
            <LazyImage
              src={item.image}
              onClick={() => item.url && window.open(item.url, '_blank')}
              className="w-65px"
              lazy={false}
            />
          </div>
        ))}
      </div>

      <p className="_tf[14] font-600 text-[var(--Text-Main-10)]">关于OP7</p>

      <div className="flex w-full flex-col gap-4px text-left">
        <p className="_tf[14] m-0 text-[var(--Text-700)] font-weight-400 leading-[1.6]">
          OP7基金旗下体育泛娱乐化的领导者，拥有欧洲马耳他博彩管理委员会（MGA）和库拉索岛博彩管理委员会（Curacao
          Gaming）颁发的在线合法博彩执照，且为体育安全协会 ( ESSA )
          的成员，并遵守欧洲游戏和博彩协会（EGBA）制定的行为和准则。
        </p>
        {/* <p className="_tf[14] m-0 text-[var(--Text-700)] font-weight-400 leading-[1.6]">
          OP7
          致力于构建一个稳定、可持续的体育泛娱乐空间，让用户在不断变化的数字环境中，始终拥有值得信赖的多维度生态体验。
        </p> */}
      </div>
      {/* <p className="w-full text-left _tf[11]  text-[var(--Text-700)] font-weight-400">
        若要在本网站注册，用户必须接受一般规则与条款。如果一般规则与条款发生更新，现有用户可以选择在上述更新生效之前（即发布后至少两周）停止使用产品和服务。
      </p> */}
    </div>
  );
};

export default Footer;
